import { DatePicker } from '@mui/x-date-pickers';
import { useStore } from '@tanstack/react-form';
import moment from 'moment';
import { useFieldContext } from '.';

type DateFieldProps = {
  label: React.ReactNode;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
  format?: string;
};

export const DateField = (props: DateFieldProps) => {
  const field = useFieldContext<string | null | undefined>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );

  const dateValue = field.state.value
    ? moment(field.state.value, 'YYYY-MM-DD')
    : null;

  return (
    <DatePicker
      label={props.label}
      value={dateValue}
      onChange={(momentDate) => {
        field.handleChange(momentDate?.format('YYYY-MM-DD') || null);
      }}
      onClose={field.handleBlur}
      minDate={props.minDate}
      maxDate={props.maxDate}
      format={props.format}
      slotProps={{
        textField: {
          fullWidth: true,
          error:
            field.state.meta.isTouched || hasTriedToSubmit
              ? field.state.meta.errors.length > 0
              : false,
          helperText:
            field.state.meta.isTouched || hasTriedToSubmit
              ? field.state.meta.errors.map((error) => error.message).join(', ')
              : undefined,
        },
      }}
    />
  );
};
